module.exports = __webpack_public_path__ + "media/images/emblems/Samnaun-coa-974968955d7c0580b92e15ff38b4704c.png";